import React from "react";
import whatsApp from "./images/whatsapp.svg";

const IconWhatsapp = () => {
    return (
        <img src={whatsApp} alt="whatsapp"/>
    );
};
export default IconWhatsapp;
